import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface RadioUniDriver extends BaseUniDriver {
  keyDown(key: string): Promise<void>;
  getValue(): Promise<string>;
  getName(): Promise<string>;
  getId(): Promise<string>;
  getLabel(): Promise<string>;
  iconExists(): Promise<boolean>;
  labelExists(): Promise<boolean>;
  isChecked(): Promise<boolean>;
  isDisabled(): Promise<boolean>;
  mouseEnter(): Promise<void>;
  mouseLeave(): Promise<void>;
}
